import { render, staticRenderFns } from "./formSwitch.vue?vue&type=template&id=5e69deee&"
import script from "./formSwitch.vue?vue&type=script&lang=js&"
export * from "./formSwitch.vue?vue&type=script&lang=js&"
import style0 from "./formSwitch.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports